// Thousands separated by a comma, as in PO (spec §12.2): 80,300.25
const NUMBER_LOCALE = "en-US";
const formatters = new Map();

/**
 * Digits after the decimal point for a TradingView pricescale (100 → 2).
 *
 * @param {number} pricescale
 * @returns {number}
 */
const pricescaleToDecimals = (pricescale) =>
  Math.max(0, Math.round(Math.log10(pricescale)));

/**
 * @param {number} price
 * @param {number} decimals - from pricescaleToDecimals
 * @returns {string}
 */
export const formatPrice = (price, decimals) => {
  let formatter = formatters.get(decimals);

  if (!formatter) {
    formatter = new Intl.NumberFormat(NUMBER_LOCALE, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    formatters.set(decimals, formatter);
  }

  return formatter.format(price);
};

/**
 * Price precision of a resolved symbol (datafeed resolveSymbol).
 *
 * @param {{ pricescale: number, minmov?: number }} symbolInfo
 * @returns {{ decimals: number, minMove: number }}
 */
export const priceFormatFromSymbol = ({ pricescale, minmov }) => ({
  decimals: pricescaleToDecimals(pricescale),
  minMove: (minmov || 1) / pricescale,
});
